<template>
    <div id="ReceivingAddress2">
        <div class="header2">
            <div class="header2Wrap">
                <div class="header2L">
                    <img src="@/assets/list/logo.png" alt />
                </div>
            </div>
        </div>
        <!-- 主体 -->
        <div class="main">
            <el-dialog :title="title" :visible.sync="dialogFormVisible" center>
                <el-form :model="form" :rules="rules" ref="form" class="forms">
                    <el-form-item label="收货人姓名：" :label-width="formLabelWidth" class="input1" prop="name">
                        <el-input v-model="form.name" autocomplete="off" placeholder="长度不超过10字符"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话：" :label-width="formLabelWidth" class="input2" prop="phone">
                        <el-input v-model="form.phone" autocomplete="off" placeholder="电话号码或手机号码"></el-input>
                    </el-form-item>
                    <el-form-item label="所在区域：" :label-width="formLabelWidth" class="input3" prop="selectedOptions">
                        <el-cascader v-model="form.selectedOptions"
                            :props="{ value: 'regionCode', label: 'regionName' }" :options="addressLists"
                            @change="handleChangeCity" ref="cascader" placeholder="请选择省/市/区/街道"></el-cascader>
                        <!-- <el-cascader
                            size="large"
                            :options="form.options"
                            v-model="form.selectedOptions"
                            @change="addressChange"
                            placeholder="请选择省/市/区/街道"
                        ></el-cascader> -->
                    </el-form-item>
                    <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
                        <el-input v-model="form.address" autocomplete="off"
                            placeholder="请输入详细地址，如道路、门牌号、楼栋号、单元等信息"></el-input>
                    </el-form-item>
                    <el-form-item label="设为默认地址" prop="delivery" class="delivery">
                        <el-switch v-model="form.delivery"></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitForm('form')">确 定</el-button>
                </div>
            </el-dialog>
            <h3 class="h3tit">
                <span>确认收货地址</span>
                <span class="addressBtn" @click="newAddr()">新建地址</span>
                <span class="addressBtn" @click="goManage()">管理收货地址</span>
            </h3>
            <div class="content1">
                <div class="add" v-if="AddressList1">
                    <p class="add1">寄送至：</p>
                    <p class="add2"
                        :title="AddressList1.ssqName + ',' + AddressList1.atShdz + '（' + AddressList1.atName + '收）' + AddressList1.atLxfs">
                        {{ AddressList1.ssqName + ',' + AddressList1.atShdz }}（{{ AddressList1.atName }}收）{{
                        AddressList1.atLxfs }}
                    </p>
                    <span class="default" v-if="AddressList1.optSfmr == 1">默认地址</span>
                    <p class="add3" @click="showMore = !showMore" v-show="AddressList.length != 0">
                        显示更多地址
                        <i class="el-icon-arrow-down"></i>
                    </p>
                </div>
                <div class="add" v-if="!AddressList1">
                    <p>您还没有创建地址,请新建地址</p>
                </div>
                <div v-if="showMore">
                    <div class="add" v-for="(item, index) in AddressList" :key="index">
                        <p class="add1"></p>
                        <p @click="selectAddress(item)" class="add2"
                            :title="AddressList1.ssqName + ',' + item.atShdz + '（' + item.atName + '收）' + item.atLxfs">
                            {{ item.ssqName + ',' + item.atShdz }}（{{ item.atName }}收）{{ item.atLxfs }}</p>
                        <span class="default" v-if="item.optSfmr">默认地址</span>
                    </div>
                </div>
                <h3 class="h3tit">
                    <span>{{ getDataList.prescription ? getDataList.prescription.rectificationName : '' }}</span>
                </h3>
                <ul class="Tabtit">
                    <li class="Tabtit1 width1">商品信息</li>
                    <li class="Tabtit1 width2">单价</li>
                    <li class="Tabtit1 width3">单位</li>
                    <li class="Tabtit1 width4">数量</li>
                    <li class="Tabtit1 width5">优惠类型</li>
                    <li class="Tabtit1 width6">商品小计</li>
                </ul>
                <!-- 药品列表 -->
                <div v-if="getDataList.spgl">
                    <div class="lists" v-for="(item, index) in getDataList.spgl" :key="index">
                        <p class="lists1 width1">{{ item.ypglName }}</p>
                        <div class="lists1 width2">
                            <!-- ￥{{item.atYpdj}} -->
                            <div class='money' v-if="item.optYhlx != 3">
                                <div class="money1">
                                    ￥{{ item.yhYpdj }}
                                </div>
                                <div class="money2">
                                    ￥{{ item.atYpdj }}
                                </div>
                            </div>
                            <div class='money' v-if="item.optYhlx == 3">
                                <div class="money3">
                                    ￥{{ item.atYpdj }}
                                </div>
                            </div>
                        </div>
                        <p class="lists1 width3">{{ item.unit }}</p>
                        <p class="lists1 width4">{{ item.atSpsl }}</p>
                        <div class="lists1 width5">
                            <div v-show="item.optYhlx == 1">{{ item.zkbl }}折优惠</div>
                            <div v-show="item.optYhlx == 2">团购</div>
                            <div v-show="item.optYhlx == 4">批发</div>
                            <div v-show="item.optYhlx == 5">批发商</div>
                            <div v-show="item.optYhlx == 3">暂无优惠</div>
                        </div>
                        <p class="lists1 width6 money3">￥{{ item.spzj }}</p>
                    </div>
                    <div class="number">
                        <p>单剂总额</p>
                        <div class="numMoney">￥{{getDataList.atYpze}}</div>
                    </div>
                    <div class="number">
                        <p>
                            购买数量
                            <span class="threePer">(服用三剂会有更好的效果)</span>
                        </p>
                        <div>
                            <p>（剂）</p>
                            <el-input-number v-model="num" @change="handleChange" :min="3" :max="10" label="描述文字"
                                class="numbers"></el-input-number>
                        </div>
                    </div>

                    <el-checkbox-group v-model="checkList" @change="djChange">
                        <div class="number" v-for="(item, index3) in getDataList.serviceGoods" :key="index3">
                            <p>药方{{ item.atName }}</p>
                            <div class="dj">
                                <el-checkbox :label="item.id">{{ '￥' + item.atPrice }}</el-checkbox>
                            </div>
                        </div>
                    </el-checkbox-group>
                    <div class="counts">
                        <div class="countsL">
                            <span @click="instructions()">
                                <i class="el-icon-warning-outline"></i> 使用说明
                            </span>
                            <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="remarks">
                            </el-input>
                        </div>
                        <div class="countsR">
                            <p class="countsR1">
                                <span class="countsR11">商品金额：</span>
                                <span class="countsR12">￥{{ jePrecision }}</span>
                                <!-- <span
                                    class="countsR12"
                                >￥{{multiplication(getDataList.payablePrice,num)}}</span> -->
                            </p>
                            <p class="countsR1">
                                <span class="countsR11">商品优惠：</span>
                                <span class="countsR12">-￥{{ yhPrecision }}</span>
                                <!-- <span class="countsR12">￥{{multiplication(getDataList.yhPrice,num)}}</span> -->
                            </p>
                            <p class="countsR1">
                                <span class="countsR11">快递方式：</span>
                                <span class="countsR12">{{ getDataList.wlgs.atKdmc }}</span>
                            </p>
                            <p class="countsR1">
                                <span class="countsR11">运费：</span>
                                <span class="countsR12" v-if="getDataList.wlgs">￥{{ getDataList.wlgs.atKdfy }}</span>
                                <!-- <span
                                    class="countsR12"
                                    v-if="getDataList.wlgs.atXzje-0>getDataList.wlgs.atKdfy-0"
                                >￥{{getDataList.wlgs.atKdfy}}</span>
                                <span class="countsR12" v-else>无运费</span> -->
                            </p>
                        </div>
                    </div>
                </div>
                <div class="up">
                    <p class="up1">金额合计</p>
                    <p class="up3" v-if="acceptDoctor == 0" @click="submitOrder()">提交订单</p>
                    <p class="up3" v-if="acceptDoctor == 1 || acceptDoctor == 2" @click="submitOrder()">咨询</p>
                    <p class="up2">
                        <span class="up21">支付金额：</span>
                        <span class="up22">{{ "￥" + allMoney }}</span>
                        <!-- <span
                            class="up22"
                            v-if="dfFlag==false && getDataList.spgl"
                        >￥{{multiplication(getDataList.paidPrice,num)+((getDataList.wlgs.atXzje-0>getDataList.wlgs.atKdfy-0)?getDataList.wlgs.atKdfy-0:0)}}</span>
                        <span
                            class="up22"
                            v-if="dfFlag==true && getDataList.spgl"
                        >￥{{multiplication(getDataList.paidPrice,num)+((getDataList.wlgs.atXzje-0>getDataList.wlgs.atKdfy-0)?getDataList.wlgs.atKdfy-0:0)+30}}</span> -->
                    </p>
                </div>
                <p style="height:30px;line-height:30px;color:#f64420;">畅通圆温馨提示，请在购买时严格严格阅读说明书，并按说明书要求服用。处方药请药师处方服用</p>
                <p style="height:30px;line-height:30px;color:#f64420;margin-bottom:40px">注：煎药用泉水</p>
                <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible2"
                    class="jwj-fz-dialog add-dialog-large">
                    <div class="notes">
                        <h3 class="titles">
                            <span>方剂名称:</span>
                            <span>{{ getDataList.prescription ? getDataList.prescription.rectificationName : ''
                                }}</span>
                        </h3>
                        <h3>主治:</h3>
                        <p>{{ getDataList.prescription ? getDataList.prescription.zhuzhi : '' }}</p>
                        <h3>禁忌:</h3>
                        <p>{{ getDataList.prescription ? getDataList.prescription.attention : '' }}</p>
                        <!-- <h3>功效:</h3>
            <p>小青龙汤，小青龙汤</p>
             <h3>注意事项:</h3>
            <p>小青龙汤，小青龙汤</p>  
             <h3>用法用量:</h3>
            <p>小青龙汤，小青龙汤</p>  
            <h3>运用:</h3>
            <p>小青龙汤，小青龙汤</p>  
            <h3>放歌:</h3>
                        <p>小青龙汤，小青龙汤</p>-->
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import {
    CodeToText,
    TextToCode
} from "element-china-area-data";
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        return {
            getDataList: [],
            num: 3, //计数
            userId: "", //用户id
            atYhmc: "", //联系人
            atLxfs: "", //联系方式
            atShdz: "", //收货地址(以英文逗号分隔)
            yfFlag: "", //1:有运费 0:无运费金额
            dfFlag: false, //1:有代煎 0:无代煎金额
            atJl: 1, //剂量
            atType: 1, //订单类型 1：普通订单 2：处方订单
            atSpsl: "", //商品数量
            spSpgl: "", //商品id
            spYhxx: "", //优惠信息id（有则传）
            spPrescriptionId: "", //处方id
            type: "", //生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
            remarks: "", //备注
            showMore: false, //是否显示所有地址
            AddressList1: {}, //默认地址
            AddressList: [], //所有地址
            title: "新建收货地址",
            dialogTableVisible: false,
            dialogFormVisible: false,
            dialogTitle: "使用说明",
            dialogFormVisible2: false,
            form: {
                name: "",
                phone: "", //号码
                address: "", //详细地址
                delivery: false, //是否默认地址
                selectedOptions: [], //地址编码list
                addressStr: "" //所在区域
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入收货人姓名",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 10,
                        message: "长度不超过10个字符",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输电话号码或手机号码",
                        trigger: "blur"
                    },
                    {
                        pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
                        message: "请输入合法手机号/电话号(区号-电话号)",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
                        trigger: "blur"
                    }
                ],
                selectedOptions: [
                    {
                        required: true,
                        message: "请选择省/市/区/街道",
                        trigger: "blur"
                    }
                ]
            },
            formLabelWidth: "120px",
            instructionsList: [],//说明书数据
            checkList: [],
            acceptDoctor: null,//存储状态1/2是咨询 0 是直接购买
            addressLists: [],//地址下拉框数据
            cityCode: [],//选中的citycode
            cityTitle: [],//选中的cityname
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        this.getAddress();//获取已有的地址列表信息
        this.getAddressList();//获取地址下拉框数据
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }
        this.type = this.$route.query.type;
        this.acceptDoctor = this.$route.query.acceptDoctor;
        this.getData();

    },
    mounted() { },
    computed: {
        // 计算金额
        jePrecision() {
            // 商品金额
            const factor = 100;
            const num1Int = Number((this.getDataList.payablePrice * factor).toFixed(2));
            const num2Int = Number((this.num * factor).toFixed(2));
            // 进行高精度乘法
            const productInt = num1Int * num2Int;

            // 将结果转换回小数，并保留两位小数
            return Number(productInt) / (factor * factor);
        },
        djPrecision() {
            // 代处理
            const factor = 100;
            const index = this.getDataList.serviceGoods.findIndex(element => element.id === this.checkList[0]);
            const num1Int = Number((this.getDataList.serviceGoods[index].atPrice * factor).toFixed(2));
            const num2Int = Number((this.num * factor).toFixed(2));

            // 进行高精度乘法
            const productInt = num1Int * num2Int;

            // 将结果转换回小数，并保留两位小数
            return Number(productInt) / (factor * factor);
        },
        yhPrecision() {
            // 优惠
            const factor = 100;
            const num1Int = Number((this.getDataList.yhPrice * factor).toFixed(2));
            const num2Int = Number((this.num * factor).toFixed(2));

            // 进行高精度乘法
            const productInt = num1Int * num2Int;

            // 将结果转换回小数，并保留两位小数
            return Number(productInt) / (factor * factor);
        },
        allMoney() {
            let num = 0;
            if (this.getDataList.wlgs) {
                if (this.checkList.length) {
                    num = this.jePrecision + this.djPrecision - this.yhPrecision + this.getDataList.wlgs.atKdfy
                } else {
                    num = this.jePrecision - this.yhPrecision + this.getDataList.wlgs.atKdfy
                }
            }

            return num.toFixed(2);
        }
    },
    methods: {
        //选择一个地址
        selectAddress(a) {
            this.AddressList.push(this.AddressList1);
             // 根据 id 去重（保留第一个出现的元素）
             this.AddressList = this.AddressList.filter(
                (item, index, self) => index === self.findIndex(
                    (t) => t.id === item.id
                )
            );
            this.AddressList.some((item, i) => {
                if (item.id == a.id) {
                    this.AddressList1 = item;
                    this.AddressList.splice(i, 1);
                    return true;
                }
            });
            this.atYhmc = a.atName; //联系人
            this.atLxfs = a.atLxfs; //联系方式
            this.atShdz = a.atShdz; //收货地址(以英文逗号分隔)
            this.addressId = a.id;//地址id
            this.showMore = !this.showMore;
        },
        addressChange(arr) {
            // console.log(arr,'hhhhhh');
            // console.log(
            //     CodeToText[arr[0]],
            //     CodeToText[arr[1]],
            //     CodeToText[arr[2]]
            // );
            if (CodeToText[arr[1]] == "市辖区") {
                this.form.addressStr =
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[2]];
            } else {
                this.form.addressStr =
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[1]] +
                    "," +
                    CodeToText[arr[2]];
            }
        },
        handleChange(value) {
            this.num = value;
        },
        getData() {
            //获取数据
            var params = {};
            params.userId = this.userId;
            params.id = this.$route.query.id;
            params.archivesId = this.$route.query.archivesId; //自测id
            params.ancientPrescription = this.$route.query.gfId; //古方id
            let url = "/ddgl/showSubmitBycfV2";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.getDataList = res.data.data;
                    if (this.getDataList.dzgl) {
                        this.AddressList1 = this.getDataList.dzgl;
                        this.atYhmc = this.getDataList.dzgl.atName; //联系人
                        this.atLxfs = this.getDataList.dzgl.atLxfs; //联系方式
                        this.atShdz = this.getDataList.dzgl.atShdz; //收货地址(以英文逗号分隔)
                        this.addressId = this.getDataList.dzgl.id;//地址id
                    } else {
                        this.AddressList1 = null;
                    }
                    // if (this.type && this.type == 2) {
                    //     //医师修正方剂
                    //     this.yfFlag = 1;
                    // } else {
                    //     if (
                    //         this.getDataList.wlgs.atXzje - 0 >
                    //         this.getDataList.wlgs.atKdfy - 0
                    //     ) {
                    //         this.yfFlag = 1; //1有运费 0无运费金额
                    //     } else {
                    //         this.yfFlag = 0; //1有运费 0无运费金额
                    //     }
                    // }

                } else if (res.data.code == 201) {
                    this.$alert(res.data.msg, "提示", {
                        confirmButtonText: "确定",
                        callback: action => {
                            this.$router.go(-1);
                        }
                    });
                    return false;
                } else {
                    this.$message(res.data.msg);
                }
            });
        },
        getAddressList() {
            var params = {};
            let url = "/city/getCityList";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.addressLists = res.data.data;

                } else {
                    this.$message(res.data.msg);
                }
            });
        },
        handleChangeCity(value) {
            // console.log(value,'e');
            this.cityCode = value;
            this.cityTitle = this.$refs["cascader"].getCheckedNodes()[0].pathLabels;
        },
        getAddress() {
            //获取地址
            var params = {};
            params.createBy = this.userId;
            let url = "/dzgl/getList";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    var list = res.data.data.list;
                    if (list.length == 1) {
                        this.AddressList1 = list[0];
                        this.atLxfs = list[0].atLxfs; //手机号
                        this.atShdz = list[0].atShdz; //地址
                        this.atYhmc = list[0].atName; //地址人名
                        this.addressId = list[0].id; //地址id
                    }
                    if (list.length == 0) {
                        this.AddressList1 = null;
                    }

                    this.AddressList = [];
                    for (var i = 0; i < list.length; i++) {
                        if (this.AddressList1 && this.AddressList1.optSfmr == 1) {
                            if (list[i].optSfmr == 0) {
                                this.AddressList.push(list[i]);
                            }
                        } else {
                            this.AddressList.push(list[i]);
                        }
                    }
                    // console.log(this.AddressList,'this.AddressList')
                } else {
                    this.$message(res.data.msg);
                }
            });
        },
        newAddr() {//新建地址
            this.dialogFormVisible = true;
            this.form.name = "";
            this.form.phone = ""; //号码
            this.form.address = ""; //详细地址
            this.form.delivery = false; //是否默认地址
            this.form.selectedOptions = []; //地址编码list
            this.form.addressStr = "" //所在区域
        },
        goManage() {
            //跳转地址详情
            this.$router.push({ path: "/myAddress" });
        },
        submitForm(formName) {
            //新增
            this.$refs[formName].validate(valid => {
                if (valid) {
                    var params = {};
                    params.atName = this.form.name; //联系人
                    params.atLxfs = this.form.phone; //联系方式
                    params.atShdz = this.form.address; //收货地址（英文逗号分隔）
                    params.ssqBmList = this.form.selectedOptions;
                    params.ssq = this.cityCode.join()
                    if (this.form.delivery) {
                        params.optSfmr = 1; //是否默认 1：默认 0：否
                    } else {
                        params.optSfmr = 0; //是否默认 1：默认 0：否
                    }
                    params.createBy = this.userId; //用户id
                    let url = "/dzgl/insert";
                    this.$http.post(url, params).then(res => {
                        if (res.data.code == 200) {
                            this.getAddress();
                            this.dialogFormVisible = false;
                        } else {
                            this.$message(res.data.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        submitOrder() {
            if (!this.AddressList1) {
                //如果没有地址
                this.$message({
                    message: "您还没有地址",
                    type: "warning"
                });
                return false;
            }

            //提交订单
            var params = {};
            params.archivesId = this.$route.query.archivesId;//诊断id
            params.serviceGoodId = this.checkList.length ? this.checkList[0] : null;//服务类型id
            params.atSpzsl = this.num; //购买数量
            params.atLxfs = this.atLxfs; //手机号
            params.atShdz = this.atShdz; //地址
            params.atType = 2; //订单类型（1：普通订单 2：处方订单）
            params.type = 0; //0 商品详情生成订单  1：购物车生成订单
            params.atYfje = this.getDataList.wlgs.atKdfy; //运费金额
            params.atYhmc = this.atYhmc; //地址人名
            params.dzglId = this.addressId; //地址id
            params.createBy = this.userId; //"CTY-20240709-0004"这种id
            params.remarks = this.remarks; //备注
            params.spPrescription = this.getDataList.prescription.id; //"CF-20240222-000060"这种id
            params.acceptDoctor = this.acceptDoctor; //是否接受医师修改方剂。2接受 0 不接受
            params.ddmxList = []; //药品信息
            for (var i = 0; i < this.getDataList.spgl.length; i++) {
                let obj = {};
                obj.atSpsl = this.getDataList.spgl[i].atSpsl; //商品数量
                obj.spSpgl = this.getDataList.spgl[i].spglId; //商品id
                obj.spYhxx = this.getDataList.spgl[i].spYhxx;
                obj.spSpggDetail = this.getDataList.spgl[i].spggDetail;
                obj.spSpgg = this.getDataList.spgl[i].spSpgg;
                obj.atBzgg = this.getDataList.spgl[i].unit;
                obj.ypName = this.getDataList.spgl[i].ypglName;
                obj.atYpdj = this.getDataList.spgl[i].atYpdj;
                obj.optYhlx = this.getDataList.spgl[i].optYhlx;
                obj.spPrescription = this.getDataList.prescription.id;
                obj.spYhxx = this.getDataList.spgl[i].spYhxx ? this.getDataList.spgl[i].spYhxx : null; //优惠信息id（有则传）
                obj.isWholesale = 0;
                obj.spGroup = null;//参团id 从参团进来的必传
                params.ddmxList.push(obj)
            }
            let url = "/ddgl/submitV2";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    if (this.acceptDoctor == 2) {
                        this.$router.push({
                            path: "/myOrder"
                        });
                    } else if (this.acceptDoctor == 0) {
                        this.$router.push({
                            path: "/payment",
                            query: { id: res.data.data.id }
                        });
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: "warning"
                    });
                }
            });
        },
        instructions() {
            this.dialogFormVisible2 = true;
            var params = {
                id: this.getDataList.prescription.id
            };
            var url = "/ddgl/cFInstruction";
            this.$http.post(url, params).then(res => {
                this.instructionsList = res.data.data;
            });
        },
        djChange(e) {
            this.checkList = [];
            if (e.length) {
                this.checkList.push(e[e.length - 1]);
            }
        }
    }
};
</script>
<style scoped>
.main {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}

.header2 {
    width: 100%;
    height: 94px;
    background-color: #f64420;
}

.header2Wrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}

.header2L {
    width: 280px;
    height: 90%;
    padding-top: 10px;
}

.header2L img {
    width: 100%;
    height: 80%;
}

.content1,
.content2 {
    width: 100%;
}

.content1::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}

.content2::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}

.h3tit {
    height: 25px;
}

.h3tit .addressBtn {
    float: right;
    display: block;
    width: 120px;
    height: 25;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 25px;
    letter-spacing: 1px;
    color: #f2961f;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    cursor: pointer;
    margin-right: 10px;
}

.add {
    width: 100%;
    height: 56px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;
}

.add p {
    float: left;
    line-height: 36px;
}

.add .add1 {
    height: 36px;
    font-weight: 600;
    width: 80px;
}

.add .add2 {
    width: 700px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.add .default {
    float: left;
    display: block;
    width: 66px;
    height: 20px;
    background-color: #f64420;
    border-radius: 10px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    letter-spacing: 1px;
    color: #ffffff;
    margin-top: 9px;
}

.add .add3 {
    float: right;
    cursor: pointer;
}

.block {
    width: 85%;
    margin: 20px auto;
}

.Tabtit {
    width: 100%;
    height: 60px;
    background-color: #f0f0f0;
    border: solid 1px #dddddd;
    box-sizing: border-box;
    padding: 10px;
}

.Tabtit li {
    float: left;
    height: 47px;
    line-height: 47px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
}

.width1 {
    width: 34%;
}

.width2 {
    width: 13%;
    text-align: center;
    float: left;
}

.flexs {
    display: flex;
    align-items: center;
    justify-items: center;
    height: 98px;
}

.width2 div {
    width: 100% !important;
    line-height: 20px;
    text-align: center;
}

.money1 {
    line-height: 18px;
    color: #f64420;
    font-weight: bold;
    font-size: 16px;
}

 .money2 {
    line-height: 14px;
    color: #999;
    font-size: 16px;
    text-decoration: line-through;
}
.money3 {
    color: #000;
    font-weight: bold;
    font-size: 16px;
}

.width3 {
    width: 13%;
    text-align: center;
    float: left;

}

.width3 span {
    display: block;
    height: 98px;
    line-height: 98px;
}


.width4 {
    width: 8%;
    text-align: center;
}

.width5 {
    width: 15%;
    text-align: center;

}

.width5 .p-li3 {
    margin-top: 35px !important;
}

.width6 {
    width: 10%;
    text-align: center;
}

.lists {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 14px;
    height: 60px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
}

.lists1,
.list2,
.list3,
.list4 {
    height: 40px;
    float: left;
    line-height: 40px;
}

.lists1 .imgs {
    height: 88px;
    width: 116px;
    float: left;
    overflow: hidden;
}

.lists1 .imgs img {
    width: 100%;
    min-height: 100%;
}

.lists1 p {
    float: left;
    height: 88px;
    line-height: 40px;
    width: 200px;
    margin-left: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

.counts {
    width: 100%;
    height: 153px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 10px 30px;
}

.countsL {
    float: left;
    width: 60%;
}

.countsL span {
    display: block;
    width: 100px;
    color: #f64420;
    cursor: pointer;
    margin-bottom: 10px;
}

.countsL input {
    float: left;
}

.countsR {
    float: right;
    width: 20%;
    margin-top: 10px;
}

.countsR11 {
    float: left;
    display: block;
    line-height: 24px;
    letter-spacing: 1px;
    color: #999999;
    width: 60%;
    text-align: right;
}

.countsR12 {
    float: left;
    display: block;
    line-height: 24px;
    letter-spacing: 1px;
    color: #f64420;
}

.up {
    width: 100%;
    height: 60px;
    line-height: 40px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    margin-top: 40px;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #666666;
}

.up1 {
    float: left;
}

.up2 {
    float: right;
}

.up2 .up22 {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #f64420;
}

.up3 {
    float: right;
    width: 140px;
    height: 40px;
    background-color: #f64420;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    margin-left: 10px;
}

.forms::after {
    height: 0;
    clear: both;
    display: block;
    visibility: hidden;
    overflow: hidden;
}

.input1,
.input2 {
    width: 50%;
    float: left;
}

.input3 {
    clear: both;
}

.delivery {
    width: 200px;
    height: 35px;
    float: right;
}

.number {
    width: 100%;
    height: 60px;
    background: #fff;
    border: 1px solid #ddd;
    margin-top: 20px;
}

.number p {
    float: left;
    line-height: 60px;
    margin-left: 10px;
    font-weight: 600;
    font-size: 16px;
}

.number div {
    float: right;
}

.number div p {
    float: right;
}

.number .dj {
    font-size: 16px;
    color: #f64420;
    margin-top: 20px;
    margin-right: 20px;
}

.numbers {
    margin-top: 10px;
}

.notes {
    width: 600px;
    margin: 0 auto 20px;
}

.titles {
    margin: 0;
    margin-bottom: 20px;
}

.number .threePer {
    font-size: 14px;
    color: #666666;
    font-weight: 500;
}
.numMoney{
    line-height: 60px;
    margin-left: 10px;
    font-weight: 600;
    font-size: 16px;
    margin-right: 20px;
}
</style>
<style>
#ReceivingAddress2 .el-radio__label {
    font-size: 16px;
    color: #f64420;
}

#ReceivingAddress2 .el-textarea {
    float: left;
    width: 80%;
}

#ReceivingAddress2 .el-textarea__inner {
    height: 90px;
}

#ReceivingAddress2 .el-dialog__header {
    border: 1px solid #cccccc;
}

#ReceivingAddress2 .el-dialog__title {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 2px;
    color: #f64420;
    text-align: center;
}

#ReceivingAddress2 .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
    font-size: 28px;
}

#ReceivingAddress2 .el-dialog--center .el-dialog__footer {
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/ReceivingAddress2.vue